import {combineReducers} from 'redux';
import {State} from 'TYPES/State';
import optionsSlice from '../slices/Options';

export default combineReducers<State>({
  Options: optionsSlice.reducer
});